import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return pathOrUrl;
}

export function wsUrl() {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/voice`;
}

export const agentsApi = {
  list: () => http.get("/agents").then((r) => r.data),
  get: (id) => http.get(`/agents/${id}`).then((r) => r.data),
  create: (data) => http.post("/agents", data).then((r) => r.data),
  update: (id, data) => http.put(`/agents/${id}`, data).then((r) => r.data),
  remove: (id) => http.delete(`/agents/${id}`).then((r) => r.data),
};

export async function previewVoice(voice_id, text) {
  const res = await http.post(
    "/voice/preview",
    { voice_id, text },
    { responseType: "blob" }
  );
  return URL.createObjectURL(res.data);
}

export async function uploadFile(file, kind) {
  const form = new FormData();
  form.append("file", file);
  const res = await http.post(`/upload?kind=${kind}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data; // { url, path }
}
